import React, {Component} from 'react';
import UserAgent from 'helpers/device';
import {connect} from 'react-redux';
import Action from 'actions';
import Const from 'constants';
import {showPopup} from 'helpers/modal';
import {Tooltip as ReactTooltip} from 'react-tooltip/dist/react-tooltip.cjs';
import {createPortal} from 'react-dom';

class App extends Component {
    constructor(props) {
        super(props);
        if (props.sportConfig.isSiteSportGameReady()) {
            props.dispatch(Action.set('ModesConfig', props.sportConfig));
        }
        if (UserAgent.isOpera()) {
            props.dispatch(
                showPopup(
                    "You have opened this page in the Opera browser. The algorithm of lineup's generation can work incorrectly in this browser",
                ),
            );
        }
    }

    componentDidUpdate(prevProps) {
        const {sportConfig, dispatch} = this.props;
        if (sportConfig.isSiteSportGameReady() && !sportConfig.isSiteSportGameEqual(prevProps.sportConfig)) {
            dispatch(Action.set('ModesConfig', sportConfig));
        }
    }

    componentDidMount() {
        const {dispatch} = this.props;

        const isDarkTheme = JSON.parse(window.localStorage.getItem(Const.THEME_LOCAL_STORAGE)) || false;

        window.localStorage.setItem(Const.THEME_LOCAL_STORAGE, isDarkTheme);

        const body = document.querySelector('html');
        body.dataset.isDarkTheme = isDarkTheme;

        dispatch(Action.do('toggleTheme', isDarkTheme));
    }

    render() {
        const {sportConfig} = this.props;

        return (
            <>
                <div className={`container ${sportConfig.isModeBacktest() ? 'backtest-mode' : ''}`}>
                    {this.props.children}
                </div>

                {createPortal(
                    <ReactTooltip
                        anchorSelect="[data-tooltip-html]"
                        positionStrategy="fixed"
                        closeOnScroll={true}
                        events={['hover', 'focus']}
                    />,
                    document.body,
                )}
            </>
        );
    }
}

function mapStatesToProps(state) {
    const {sportConfig, theme} = state;

    return {
        sportConfig,
        theme,
    };
}

export default connect(mapStatesToProps)(App);
